import React from 'react'
import PropTypes from 'prop-types'
import { Link, Stack, Typography } from '@mui/material_modern'
import InputV2 from 'components/generic/form/InputV2'
import Switch from 'components/generic/form/Switch'

const MaterialComplianceForm = ({ methods, isUpdate }) => {
  const {
    control,
    watch,
    formState: { errors },
    clearErrors,
  } = methods

  const isPaymentHoldEnabled = watch('paymentHold.enabled')
  const isDaysValid = !watch('paymentHold.enabled') || watch('paymentHold.days') >= 1
  // commented out until v2 of payment holds
  // const isPaymentMethodsEnabled = watch('paymentMethods.enabled')
  // const isPaymentMethodsValid = !isPaymentHoldEnabled || watch('paymentMethods')?.length > 0

  // const options = [
  //   { id: 'check', name: 'Check' },
  //   { id: 'cash', name: 'Cash' },
  // ]

  return (
    <Stack key="compliance" flexGrow={1} ml={4}>
      <Typography variant="h5">Compliance</Typography>
      <Stack>
        {/* Bypass Compliance Restrictions */}
        <Stack direction="row" alignItems="center" sx={{ marginBottom: 1, marginTop: 1 }}>
          <Typography variant="h6" mr={2}>
            Bypass Compliance Restrictions
          </Typography>
          <Switch
            label="Enabled"
            name="complianceOptOut"
            control={control}
            defaultValue={false}
            data-testid="compliance-bypass-switch"
            onChange={toggledBool => {
              if (toggledBool) {
                // Clear other compliance-related fields when bypass is enabled
                clearErrors('paymentHold')
                methods.setValue('paymentHold.enabled', false)
                methods.setValue('paymentHold.days', 0)
              }
            }}
          />
        </Stack>
        <Typography
          variant="body2"
          sx={{
            marginBottom: 1,
            color: 'textSecondary',
            maxWidth: '50%',
            lineHeight: 1.5,
          }}
        >
          When enabled this will override{' '}
          <Link
            href="/app/settings/purchases/payment#compliance-requirements-for-payments"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 'bold', marginRight: 0.5 }}
          >
            required payment fields
          </Link>
          ,{' '}
          <Link
            href="/app/settings/purchases/payment#commodity-type-thresholds"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 'bold', marginRight: 0.5 }}
          >
            FE/NF cost thresholds
          </Link>
          , and exclude inbound tickets containing only opted out materials from compliance reporting.
        </Typography>

        {/* Payment Hold Section */}
        <Stack direction="row" width={{ xs: '100%', md: '50%' }} alignItems="center" sx={{ marginTop: 1 }}>
          <Typography variant="h6" mr={1}>
            Payment Hold
          </Typography>
          <Switch
            label="Enabled"
            name="paymentHold.enabled"
            defaultValue={false}
            control={control}
            data-testid="payment-hold-enabled"
            variant="outlined"
            onChange={toggledBool => {
              // If Payment Hold is enabled, uncheck Compliance Opt-Out
              if (toggledBool) {
                methods.setValue('complianceOptOut', false)
                clearErrors('complianceOptOut')
              }
              // Clear errors for Payment Hold and Payment Methods
              const fieldsToClear = ['paymentHold', 'paymentMethods']
              fieldsToClear.forEach(value => clearErrors(value))
            }}
          />
        </Stack>

        {/* Static Note */}
        <Typography variant="body2" sx={{ marginTop: 1, color: 'textSecondary' }}>
          Please note that payment holds will only apply to retail customers.
        </Typography>

        <Stack width={{ xs: '100%', md: '50%' }} sx={{ marginTop: 2 }}>
          <InputV2
            name="paymentHold.days"
            label="Days"
            defaultValue={0}
            type="number"
            control={control}
            disabled={!isPaymentHoldEnabled}
            data-testid="payment-hold-days"
            variant="outlined"
            error={!!errors?.paymentHold?.days || (isUpdate && !isDaysValid)}
            helperText={isUpdate && !isDaysValid ? 'A value is required.' : errors?.paymentHold?.days?.message}
          />
          {/* commented out until v2 of payment holds */}
          {/*<Typography variant="span" mr={1} mt={2}>*/}
          {/*  Acceptable Payment Methods*/}
          {/*</Typography>*/}
          {/*<List*/}
          {/*  name="paymentMethods"*/}
          {/*  control={control}*/}
          {/*  defaultValue={[]}*/}
          {/*  data-testid="payment-methods"*/}
          {/*  required={false}*/}
          {/*  items={options}*/}
          {/*  disabled={!isPaymentHoldEnabled}*/}
          {/*  hasCheckboxes*/}
          {/*  error={!!errors?.paymentMethods || (isUpdate && !isPaymentMethodsValid)}*/}
          {/*  helperText={*/}
          {/*    isUpdate && !isPaymentMethodsValid ? 'At least one method is required.' : errors?.paymentMethods?.message*/}
          {/*  }*/}
          {/*/>*/}
        </Stack>
      </Stack>
    </Stack>
  )
}

MaterialComplianceForm.propTypes = {
  methods: PropTypes.object,
  isUpdate: PropTypes.bool,
}

MaterialComplianceForm.defaultProps = {
  methods: {},
  isUpdate: false,
}

export default MaterialComplianceForm
